import { Button } from "react-migration/components/Button";

import hasFeature from "src/js/stores/user/actions/hasFeature";
import Feature from "src/js/stores/user/Feature";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

import { setShowUpgradeModal } from "src/js/stores/navigation/actions";
import { logEventV2, UpgradeEventLocation } from "react-migration/lib/util/logEventV2";

export type UpgradeButtonProps = {
  source: UpgradeEventLocation;
  className?: string;
  children?: React.ReactNode;
};

export const handleUpgrade = ({ source }: { source: UpgradeEventLocation }) => {
  logEventV2({ name: "Upgrade", properties: { source, action: "initiate-upgrade" } });
  setShowUpgradeModal(true);
};

export const shouldShowUpgrade = (source: UpgradeEventLocation) => {
  return !(!hasFeature(Feature.upgradeButton) && source !== "QuickInsights" && source !== "compsAndLocal");
};

export const UpgradeButton = ({ source, className, children }: UpgradeButtonProps) => {
  const { t } = useTranslation();

  if (!shouldShowUpgrade(source)) {
    return null;
  }

  return (
    <Button
      variant="primary"
      className={className}
      data-testid="upgrade-button"
      onClick={() => handleUpgrade({ source })}
      tailIcon="lt-arrow-right-s-line"
    >
      {children || t("nav.nav.upgrade")}
    </Button>
  );
};
